// The Forecasting tab's body (2026-10-27): a switch between its views. Phone & Chat,
// Email, Support and (2026-10-29) the Overview. Each view fetches its own
// report when first opened and keeps it while the tab is open.
import { useState } from 'react'
import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material'
import ForecastPhoneChat from './ForecastPhoneChat.jsx'
import ForecastEmail from './ForecastEmail.jsx'
import ForecastSupport from './ForecastSupport.jsx'
import ForecastOverview from './ForecastOverview.jsx'

const VIEWS = [
  { value: 'phone-chat', label: 'Phone & Chat' },
  { value: 'email', label: 'Email' },
  { value: 'support', label: 'Support' },
  { value: 'overview', label: 'Overview' },
]

export default function ForecastingTab() {
  const [view, setView] = useState('phone-chat')
  const [opened, setOpened] = useState(() => new Set(['phone-chat']))
  const pick = (_e, next) => {
    if (!next) return
    setView(next)
    setOpened((all) => (all.has(next) ? all : new Set(all).add(next)))
  }
  return (
    <Box>
      <ToggleButtonGroup size="small" exclusive value={view} onChange={pick} aria-label="Forecasting view" sx={{ mb: 2 }}>
        {VIEWS.map((v) => <ToggleButton key={v.value} value={v.value}>{v.label}</ToggleButton>)}
      </ToggleButtonGroup>
      {opened.has('phone-chat') && <Box hidden={view !== 'phone-chat'}><ForecastPhoneChat /></Box>}
      {opened.has('email') && <Box hidden={view !== 'email'}><ForecastEmail /></Box>}
      {opened.has('support') && <Box hidden={view !== 'support'}><ForecastSupport /></Box>}
      {opened.has('overview') && <Box hidden={view !== 'overview'}><ForecastOverview /></Box>}
    </Box>
  )
}
